import $ from 'jquery';

class Projects {
    constructor() {
        this.projects = Array();
        this.currentPage = 1;
        this.maxPages = 0;
        this.viewMoreBtn = $("#view-more-btn");
        this.viewMoreSection = $(".projects--view__more");
        this.popUp = $(".popup--blur");
        this.selectedProject = Array();
        this.containerImage = $(".container--image");
        this.containerHeader = $(".container--header");
        this.projectContent = $(".project--content");
        this.projectCategories = $(".project--categories");
        this.events();
    }
    events() {
        window.addEventListener("load", () => {
            this.getProjects();
        });
        this.viewMoreBtn.on("click", () => {
            this.showProjects(this.currentPage);
            this.currentPage = this.currentPage + 1;
            if(this.currentPage == this.maxPages) {
                this.hideViewMoreSection();
            }
        });
        $(document).on("click", ".box", (e) => {
            this.activatePopup();
            if(e.target.dataset["id"]) {
                this.populatePopupContainer(e.target.dataset["id"]);
            } else {
                this.populatePopupContainer(e.target.parentNode.dataset["id"]);
            }
        });
        this.popUp.on("click", (e) => {
            if(e.target.className !== "popup--blur__container" && e.target.className !== "container--image" && e.target.className != "project--content__container" && e.target.className !="center--content" && e.target.className != "container--header" && e.target.className != "project--content" && e.target.className !== "project--categories" && e.target.className != "project--category") {
                this.deActivatePopup();
            }
        });
    }
    showProjects(page) {
        let i = (page * 10);
        let limit = i + 10;
        let projectCards = '';
        while(i<limit) {
            projectCards = projectCards + `<div class="box" style="background:url(${this.projects[i].image}); background-size:cover; background-position:${this.projects[i].backpos};"><div class="project--header" data-id="${this.projects[i].id}"><h4>${this.projects[i].title}</h4></div></div>`;
            i++;
        }
        $(`.projects--boxes__container:nth-child(${page + 2})`).append(projectCards);
        $(`.projects--boxes__container:nth-child(${page + 2})`).addClass("activate-card-layer");
    }
    getProjects() {
        var link;
        link = projectData.root_url + "/wp-json/projects/v1/results"
        $.ajax({
            type: "GET",
            url: link,
            dataType: 'json',
            success: (projects, status, request) => {
                this.projects = projects;
                this.maxPages = (this.projects.length) / 10;
            },
            error: (result) => {
                console.log("Failed");
            }
        })
    }
    hideViewMoreSection() {
        this.viewMoreSection.addClass("hide-view-more");
    }
    activatePopup() {
        this.popUp.toggleClass("popup--blur__active");
        $("body").css("overflow", "hidden");
    }
    deActivatePopup() {
        this.popUp.toggleClass("popup--blur__active");
        $("body").css("overflow", "visible");
    }
    populatePopupContainer(projectID) {
        let active = this.projects.filter((project) => project.id == projectID);
        this.containerImage.css("background", `url(${active[0].image})`);
        this.containerImage.css("background-size", "cover");
        this.containerImage.css("background-position", `${active[0].backpos}`);
        this.containerHeader.text(active[0].title);
        this.projectContent.text(active[0].content);
        this.projectCategories.html(active[0].categories.map(category => `<div class="project--category">${category}</div>`).join(''));
    }
}
export default Projects;